<template>
	<div id="indexpage"  v-title :data-title="title" style="background-color: #19213c; height: 100%;">   
	 <leftnav mkcode="D" itemcode="D-ZSHJ"  :smScrennFull="true"></leftnav> 
		<div class="por"> 
		<!-- 全屏开始 -->
		<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
		<!-- 全屏结束 -->
			<div class="index-swiper">
				<!-- <h2 class="title dataswipertitle" @mouseover="drawer = true">{{userdata.cityText}}{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2> -->
				<daswiperNav :title="title" :indexnum="5"  navcode="ZSHJ" :fulltitle="true"></daswiperNav>
				<div class="indexflex zshjswiper">
					<div class="col5 colbox bludbd zshjswiper_left">
						<div class="pdrl30">
						<h3 class="blocktitle">招商环境</h3> 
						<div id="zshj_radar"></div>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="zshj_radar_table">
							<tr><th>指标</th><th>得分</th><th>排名</th><th>解读</th></tr>
							<tr v-for="(item,i) in pagedata.cityEnv" :class="i%2 != 0?'spbg':''">
								<td>{{item.label}}</td>
								<td>{{item.value}}</td>
								<td>{{item.rank}}</td>
								<td>{{item.summary}}</td>
							</tr>
						</table>
						</div> 
					</div>
					<div class="col5 colbox">
						<div class="flexcss">
							<div class="col5 colbox bludbd zshjswiper_h1">
								<div class="pdrl15">
									<h3 class="blocktitle">投资态势</h3>
									<ul class="zshj_ts flexcss"> 
										<li>
											<h5 class="fwn">去年投资总额</h5>
											<strong class="yellfont">{{pagedata.invest.y2020.money}}{{pagedata.invest.unit.split('、')[1]}}</strong>  
										</li>
										<li>
											<h5 class="fwn">今年投资总额</h5>
											<strong class="yellfont">{{pagedata.invest.y2021.money}}{{pagedata.invest.unit.split('、')[1]}}</strong>  
										</li>
										<li> 
											<h5 class="fwn">去年投资数量</h5>
											<strong class="yellfont">{{pagedata.invest.y2020.num}}{{pagedata.invest.unit.split('、')[0]}}</strong>
										</li>
										<li> 
											<h5 class="fwn">今年投资数量</h5>
											<strong class="yellfont">{{pagedata.invest.y2021.num}}{{pagedata.invest.unit.split('、')[0]}}</strong>
										</li>
									</ul>
								</div>
							</div>
							<div class="col5 colbox bludbd zshjswiper_h1">
								<div class="pdrl15"> 
									<h3 class="blocktitle">土地交易</h3>
									<ul class="zshj_jy flexcss">
										<li> 
											<h5 class="fwn">去年成交总面积</h5>
											<strong class="yellfont">{{pagedata.land.y2020.size}}{{pagedata.land.unit.split('、')[0]}}</strong>
										</li>
										<li> 
											<h5 class="fwn">今年成交总面积</h5>
											<strong class="yellfont">{{pagedata.land.y2021.size}}{{pagedata.land.unit.split('、')[0]}}</strong>
										</li>
										<li> 
											<h5 class="fwn">去年成交总额</h5>
											<strong class="yellfont">{{pagedata.land.y2020.money}}{{pagedata.land.unit.split('、')[1]}}</strong>
										</li>
										<li> 
											<h5 class="fwn">今年成交总额</h5>
											<strong class="yellfont">{{pagedata.land.y2021.money}}{{pagedata.land.unit.split('、')[1]}}</strong>
										</li>
									</ul>
								</div> 
							</div>
						</div>
						<div class="bludbd zshjswiper_h2">
							<div class="pdrl15">
								<h3 class="blocktitle">投资趋势</h3>
								<div id="zshj_trend"></div>
							</div>
						</div>
						<div class="bludbd zshjswiper_h3">
							<div class="pdrl15">
								<h3 class="blocktitle">招商项目</h3>
								<div class="thbox">
								<ul class="flexcss"> 
									<li class="th_list1">项目名称</li>
									<li class="th_list2">所在地区</li>
									<li class="th_list2">所属行业</li>
									<li class="th_list2">项目类型</li>
									<li class="th_list3">项目金额（万元）</li>
									<li class="th_list2">日期</li>  
									</ul> 
									</div>
									<div class="zshj_scrollbox">
									<vue-seamless-scroll :data="pagedata.investList"  :class-option="defaultOption" class="table_list fl"> <!-- :data="colors"  :class-option="defaultOption" -->
									<ul class="flexcss" v-for="list in pagedata.investList">  <!-- v-for="list in pagedata.investList" -->
										<li class="th_list1" ><span>{{list.projectName}}</span></li>		<!--   @click="routerlinkid('/news',lsit.id)"-->
										<li class="th_list2">{{list.area.substring(3)}}</li>
										<li class="th_list2">{{list.industry}}</li>
										<li class="th_list2">{{list.type}}</li>
										<li class="th_list3">{{list.money}}</li>
										<li class="th_list2">{{list.date}}</li>
										</ul> 
								</vue-seamless-scroll >
							</div> 
							</div>
						</div>
						<!-- <div class="bludbd zshjswiper_h4">
							<div class="pdrl15"> 
							<h3 class="blocktitle">优惠政策</h3>
							<div class=" flexcss zshjswiper_h4_listbox"> 
								<ul class="zshjswiper_h4_list " v-for="(list,i) in pagedata.policy" :class="i%2!=0?'zshjswiper_h4_list2':'zshjswiper_h4_list1'"> 
									<li class="zshjswiper_h4_title">{{list.name}}</li>
									<li class="yellfont">{{list.value}}{{list.unit}}</li>
									<img src="../../assets/images/iSpt11.gif" />
								</ul>  
							</div>
							</div>
						</div> -->
					</div>  
				</div>
			</div>
		</div>
		<!-- </Resize> -->
	</div>
</template> 
<script>
	import vueSeamlessScroll from 'vue-seamless-scroll';
	export default {
		name: 'zhaoshanghuanjing',
		data() {
			return {  
					isCollapse:false,
					isFullscreen: false,
					direction:"ltr",  //btt
					direction2:"btt",  //btt
					 drawer: false,
						drawer2: false,
						modal:false,	
				components:{
				        vueSeamlessScroll
				    },
				title:"招商环境数字大屏", bgcolor:"#19213c",
				userdata:{}, 
				pagedata:{cityEnv:[],invest:{unit:'',y2020:{money: 0,num: 0},y2021:{money: 0,num: 0}},land:{unit:'',y2020:{money: 0,size: 0},y2021:{money: 0,size: 0}}},
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				}, 
				mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				//假数据 
			}
		},
		props: {
			msg: String,
		},
		computed: {
		defaultOption () {
			return {
				step: 0.5, // 数值越大速度滚动越快
				limitMoveNum: this.pagedata.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
			} 
		},　　
		mounted() {
			document.getElementById('app').style.background=this.bgcolor;
			console.log(document.getElementById('app'));
			this.userdata=this.getuseriformation();
			console.log(this.userdata);
			// this.getajaxdata();
			var _this=this;
			this.bus.$emit('loading', true);
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
		this.getajaxdata();
		},
		methods: {  
			getajaxdata(){
				var _this=this;
				// this.bus.$emit('loading', true);
				console.log(this.title);
				this.$axios.get(this.$api.cyl.govsaaschart.investenv(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log(res.data);
					if(res.data.success){ 
						_this.bus.$emit('loading', false);
						_this.pagedata=res.data.data; 
							var Trenddata=res.data.data.investTrend; 
								// console.log("getajaxdata",res);
								console.log('pagedata',_this.pagedata);
								// console.log('ssssdata',Trenddata[0].date);
						// setTimeout(function(){
						_this.holdradarFun('zshj_radar',_this.pagedata.cityEnv);  
						_this.trendFun('zshj_trend',Trenddata);
						_this.bus.$emit('loading', false);
						// },1500)
						
					 
				
					} 
				}).catch(function (error) { 
					_this.bus.$emit('loading', false);
					// 请求失败处理 console.log(error);
				});  
			},
			
			//雷达图
			holdradarFun(el,data){
				console.log(data);
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var myChart = echarts.init(document.getElementById(el)); 
				var _this = this,valueData=[];
				console.log("holdradarFundata",data[0].value)
				for(var i=0;i<data.length;i++){
					valueData.push(data[i].value);
					data[i].name=data[i].label;
					data[i].max=100;
					if(i == 0){
						data[0].axisLine={ show:true};
						data[0].axisLabel=	{show:true,color:"#fff",fontSize:16}
					}
				} 
				var option = {
				  title: { text: ' ' },
				  legend: {show:false},
				  label:{ show:false, },   //标签数值显示
				  tooltip:{show:true,  
							   // formatter: function (params) {
							   //         // var result = "" ;
										// 								// var val = params.value;
							   //         // var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>' ;   // 定义第一个数据前的圆点颜色
										// 					   //    for(var i = 0 ;i<val.length;i++){ 
										// 								// 			result += dotHtml + params.name + params.value[i]; 
										// 								// 			// console.log('result',result)
										// 								// 	 }
										// 										console.log(params); 
										// 										// result += dotHtml + params.name + params.value[0]; 
										// 										// return result;
							           
							   //     } 
							},
				  radar: { 
								radius:"75%",
								axisName:{fontSize:16,color:'#fff'},
				    shape: 'circle',
				    indicator: data,
								splitArea: {
								//分割区域的样式	
								areaStyle:{
									color: ['#fff', '#fff', '#fff', '#c3c3c3','#1F345E'],
									shadowColor: 'rgba(0, 100, 0, 0.3)',
									opacity: 0.1,
								}
							},
							splitLine:{lineStyle:{type:'dashed'}},
							axisLine: { show:false,} ,  //设置所有刻度线不显示
				  },
				  series: [{
								name: '得分',
								type: 'radar',
								data: [{value:valueData, name: '得分'}],
								areaStyle: {normal: { 	color: '#377ad3', opacity:.6, shadowColor:'#2c3F56', 	shadowBlur:3, 	shadowOffsetY:2, shadowoffsetX:5 }}
						}]
				};
				myChart.setOption(option);
				var startCharts = null;
				// 2、鼠标移动上去的时候的高亮动画
				// myChart.on('mouseover', function(param) {
				// 	isSet = false
				// 	clearInterval(startCharts)
				// 	// 取消之前高亮的图形
				// 	myChart.dispatchAction({
				// 		type: 'downplay',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	// 高亮当前图形
				// 	myChart.dispatchAction({
				// 		type: 'highlight',
				// 		seriesIndex: 0,
				// 		dataIndex: param.dataIndex
				// 	})
				// 	// 显示 tooltip
				// 	myChart.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: param.dataIndex
				// 	})
				// });
				// var chartHover = function() {
				// 	var dataLen = option.series[0].data.length
				// 	// 取消之前高亮的图形
				// 	myChart.dispatchAction({
				// 		type: 'downplay',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
				// 	// 高亮当前图形
				// 	myChart.dispatchAction({
				// 		type: 'highlight',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// 	// 显示 tooltip
				// 	myChart.dispatchAction({
				// 		type: 'showTip',
				// 		seriesIndex: 0,
				// 		dataIndex: charPie3currentIndex
				// 	})
				// }
				// startCharts = setInterval(chartHover, 2000)
				// // 4、鼠标移出之后，恢复自动高亮
				// myChart.on('mouseout', function(param) {
				// 	if (!isSet) {
				// 		startCharts = setInterval(chartHover, 2000)
				// 		isSet = true
				// 	}
				// });
			},
			
			//投资趋势
			trendFun(el,data){ 
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var  trendchart= echarts.init(document.getElementById(el)); 
				var _this = this,xdata=[],money=[],num=[];
				for(var i=0;i<data.length;i++){
					xdata.push(data[i].date);
					money.push(data[i].money);
					num.push(data[i].num);
				}
				// console.log('aaa',xdata,money,num);
				var 	option = {
				  tooltip: {
				    trigger: 'axis', 
							formatter: function (params) {
							        var result = ''
							        var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'    // 定义第一个数据前的圆点颜色
															var dotHtml2= '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#d0d12b"></span>'
							        result += dotHtml + ' 投资金额（亿元） ' + params[0].data + "</br>" + dotHtml2 + ' 投资数量（个） ' + params[1].data;
							        return result
							    },
						confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内
				  }, 
				  legend: {show:false },
						grid:{  x:25, y:10, x2:25,y2:20 },
				  xAxis: [
				    {
				      type: 'category',
				      data: xdata,
				      axisPointer: {
				        type: 'shadow'
				      },
										axisLine: {
											show:true,
										lineStyle:{
											color:'#eee',
										}
										},
				    }
				  ],
				  yAxis: [
				    {
				      type: 'value',
				      name: ' ',
				      min: 0,
				      max: 60,  
				      axisTick:{"show":true },
										axisLine: {
											show:true,
										lineStyle:{
											color:'#eee',
										}
										},  //显示y轴刻度线
										splitLine:{show:false}, //不显示分割线
				    },
				    {
				      type: 'value',
				      name: ' ',
				      min: 0,
				      max: 35,
				      interval: 5, 
										splitLine:{ show:false}, //不显示分割线
										axisLine: {
											show:false,
										lineStyle:{
											color:'#eee',
										}
										},  //显示y轴刻度线
				    }
				  ],
				  series: [ 
				    {
				      name: '投资金额',
				      type: 'bar',
										barWidth:30,
										color:'#1890ff',
				      data:money
				    },
				    {
				      name: '投资数量',
				      type: 'line',
				      yAxisIndex: 1,
										color:'#d0d12b',
										itemStyle:{
											normal:{
												lineStyle:{
													type:"dotted"
												}
											}
										},
				      data:num
				    }
				  ]
				};
				trendchart.setOption(option);
				var startCharts = null;
				// 2、鼠标移动上去的时候的高亮动画
				trendchart.on('mouseover', function(param) {
					isSet = false
					clearInterval(startCharts)
					// 取消之前高亮的图形
					trendchart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 高亮当前图形
					trendchart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
					// 显示 tooltip
					trendchart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: param.dataIndex
					})
				});
				var chartHover = function() {
					var dataLen = option.series[0].data.length
					// 取消之前高亮的图形
					trendchart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
					// 高亮当前图形
					trendchart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
					// 显示 tooltip
					trendchart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: charPie3currentIndex
					})
				}
				startCharts = setInterval(chartHover, 2000)
				// 4、鼠标移出之后，恢复自动高亮
				trendchart.on('mouseout', function(param) {
					if (!isSet) {
						startCharts = setInterval(chartHover, 2000)
						isSet = true
					}
				});
			}
 
	
	
	
	
		}
	}
</script>

<style scoped="scoped">
#app{
		background-color: #041034;
	}
 @import url("../../css/dataswiper.css");
</style>
